/**
* @name: LayoutBody
* @author: weiyong
* @date: 2022-10-01 08:43
* @description：LayoutBody
* @update: 2022-10-01 08:43
*/
<template>
  <div :class="[prefixCls,getCollapsed?'mix':'expand']">
      <slot></slot>
  </div>
</template>

<script lang="ts">
export default {
  name: "LayoutBody"
}
</script>

<script lang="ts" setup>
import {useDesign} from "@/hooks/web/useDesign";
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";
const { prefixCls } = useDesign('layout-body');

const {
  getCollapsed,
  getSplit,
} = useMenuSetting();
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-layout-body';

.@{prefix-cls} {
  --left-min-menu-width:55px;
  --left-menu-width:200px;

  background-color: transparent;
  margin-left: var(--left-menu-width,200px);
  width: auto;
  height: 100%;
  overflow: hidden;
  flex:1;
  &.expand{
    margin-left: var(--left-menu-width,200px);
  }
  &.mix{
    margin-left: var(--left-min-menu-width,55px);
  }
}
</style>
